import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { GridWrapper } from '../../../_models/GridWrapper';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../../_store/mainStoreState';
import { GridComponent } from '@progress/kendo-angular-grid';
import { GoldenLayoutContainerInjectionToken, WidgetHostDirective } from '../../../_directives/widget-host.directive';
import { ComponentContainer } from 'golden-layout';
import { LogService } from '../../../_services/http/log.service';
import { loadLogsAction, selectAllLogs } from '../../../_store/LogsStore/logs.store';
import { Log } from '../../../_models/Log';
import { distinct } from '@progress/kendo-data-query';

@Component({
  selector: 'app-log-list',
  templateUrl: './log-list.component.html',
  styleUrls: ['./log-list.component.scss'],
})
export class LogListComponent extends WidgetHostDirective implements OnInit {
  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  // Grid attributes
  public gridWrapper = new GridWrapper<Log>(
    'Log',
    this.store.select(selectAllLogs),
    {
      logic: 'or',
      filters: [
        {
          field: 'nomSousSysteme',
          operator: 'contains',
        },
        {
          field: 'utilisateur',
          operator: 'contains',
        },
        {
          field: 'ipUtilisateur',
          operator: 'contains',
        },
        {
          field: 'message',
          operator: 'contains',
        },
      ],
    },
    this.kendoGrid
  );

  constructor(
    @Inject(GoldenLayoutContainerInjectionToken) container: ComponentContainer,
    elRef: ElementRef,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    store: Store<MainStoreState>,
    private crudService: LogService
  ) {
    super(container, elRef.nativeElement, renderer, viewContainerRef, store);
  }

  ngOnInit(): void {
    this.store.dispatch(loadLogsAction({ force: false }));
    this.crudService.refreshHubConnection();
  }

  ngOnDestroy(): void {
    this.gridWrapper.destroy();
  }

  reload(): void {
    this.store.dispatch(loadLogsAction({ force: true }));
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.internalData, fieldName).map(
      // @ts-ignore
      (item) => item[fieldName]
    );
  }
}
